import { LoaderFunction } from 'react-router-dom';

import {
  ContentfulInstructorLedTraining,
  ContentfulInstructorLedTrainingResponse,
  GET_INSTRUCTOR_LED_TRAINING,
} from 'src/graphql/queries/GetInstructorLedTraining';
import { fetchGraphQL } from 'src/services/contentful/client';

export interface SessionData {
  id: string;
  month: string;
  day: string;
  label: string;
  time: string;
}

export interface EnrollBannerData {
  meetingId: string;
  materialsLink: string;
  countdown: {
    days: number;
    hours: number;
  };
}

interface GetInstructorLedTrainingQueryVariables {
  slug: string;
  preview: boolean;
}

const getInstructorLedTrainingData = async (
  slug: string,
  preview: boolean,
): Promise<ContentfulInstructorLedTraining | undefined> => {
  try {
    const response = await fetchGraphQL<
      ContentfulInstructorLedTrainingResponse,
      GetInstructorLedTrainingQueryVariables
    >(GET_INSTRUCTOR_LED_TRAINING, {
      slug,
      preview,
    });

    return response.instructorLedTrainingCollection.items[0];
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error fetching ILT data:', error);

    return undefined;
  }
};

export interface Props {
  courseId: string;
  iltData?: ContentfulInstructorLedTraining;
  session: SessionData;
  enrollBanner: EnrollBannerData;
}

export const loader: LoaderFunction = async ({ params }): Promise<Props> => {
  const courseId = params.courseId ?? '';
  const preview = false; // Can be updated based on environment or query params

  const iltData = await getInstructorLedTrainingData(courseId, preview);

  // Mock session data - will be updated from Contentful later
  const session: SessionData = {
    id: '1',
    month: 'SEP',
    day: '25',
    label: 'Wednesday, October 29th',
    time: '8AM-10AM CST',
  };

  // Mock enroll banner data - will be updated from Contentful later
  const enrollBanner: EnrollBannerData = {
    meetingId: 'abc-defg-hij',
    materialsLink: 'https://example.com/materials',
    countdown: {
      days: 5,
      hours: 12,
    },
  };

  return {
    courseId,
    iltData,
    session,
    enrollBanner,
  };
};
